export default __webpack_public_path__ + "22d6ae4061137e75951b5afe64d13be7.svg";